export default function WhyChooseUs() {
  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: 'Fully Insured',
      description: 'Comprehensive insurance coverage for complete peace of mind during your move'
    },
    {
      icon: 'ri-time-line',
      title: 'Punctual Service',
      description: 'We value your time and always arrive on schedule, ready to work'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Transparent Pricing',
      description: 'No hidden fees or surprises. Clear, upfront quotes for all services'
    },
    {
      icon: 'ri-team-line',
      title: 'Experienced Team',
      description: 'Professional movers with years of experience handling all types of items'
    },
    {
      icon: 'ri-tools-line',
      title: 'Proper Equipment',
      description: 'Modern vans and professional moving equipment for safe transport'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Round-the-clock customer service to answer your questions anytime'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-4">Why Choose Us</h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We're committed to providing the best moving experience with professionalism, reliability, and care
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-5">
                <i className={`${benefit.icon} text-3xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
